export default "__VITE_ASSET__DKyfwp9E__"